<style scoped lang="scss">
.footer-box{
  background: #f0f5f4;

}
.footer-link {
  display: flex;
  max-width: 1200px;
  padding-top: 100px;
  margin: 0 auto 100px;
  border-top: 1px solid #e7e7e7;
  justify-content: space-between;
  font-family: 'syht';

  dl {
    font-size: 16px;
    dt {
      color: #000;
      font-weight: bold;
      margin-bottom: 40px;
      img {
        width: 180px;
      }
    }
    dd {
      margin-bottom: 30px;
      display: flex;
      margin-left: 0;
      font-weight: 600;
      color: #777;
      a{
        cursor: pointer;
      }
    }
  }
.copyright{
  width: 1100px;
  margin: 0 auto;
}
.copyright img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin: -3px 2px 0 0;
}
.copyright p {
  line-height: 1.8;
}
.copyright span {
    display: inline-block;
    margin-right: 15px;
}
 .copyright a {
  color: #414a60;
}
}
</style>
<template>
  <div class="footer-box">
    <footer class="footer-link">
      <dl>
        <dt>
          <img src="../../assets/newHome/ssy.png" alt="">
        </dt>
      </dl>
      <dl>
        <dt style="text-align:center">产品</dt>
        <dd><a>BBT 乾元模型</a></dd>
        <dd><a>BBT 金融模型</a></dd>
        <dd><a>BBT 代码模型</a></dd>
        <dd><a>BBT 文生图模型</a></dd>
      </dl>
      <dl>
        <dt>文档</dt>
        <dd><a>API文档</a></dd>
        <dd><a>使用手册</a></dd>
        <dd><a>常见问题</a></dd>
      </dl>
      <dl>
        <dt>加入我们</dt>
        <dd><a>公司介绍</a></dd>
        <dd><a>价值使命</a></dd>
        <dd><a>社会招聘</a></dd>
      </dl>
      <dl>
        <dt>法律声明</dt>
        <dd><a>服务协议</a></dd>
        <dd><a>隐私政策</a></dd>
      </dl>
    </footer>
    <div class="copyright" style="text-align: center;padding-bottom: 40px">
        <p>
            <span>Copyright © 2023 超对称(北京)科技有限公司</span><span><a href="https://beian.miit.gov.cn/" rel="nofollow" ka="link-icp" target="_blank">  京ICP备16038314号</a></span>
            <!-- <span>
                  <a href="https://www.zhipin.com/activity/cc/businesslicense.html" rel="nofollow" ka="link-businesslicense" target="_blank">
                      <img src="https://static.zhipin.com/v2/web/geek/images/icon-badge-1.png" alt="">
                      电子营业执照
                  </a>
            </span>
            <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502032801" rel="nofollow" ka="link-beian" target="_blank"><img src="https://static.zhipin.com/v2/web/geek/images/icon-beian.png" alt=""> 京公网安备11010502032801</a></span>
            <span><a href="http://sdwj.zhipin.com/web/index.html" rel="nofollow" ka="link-sdwj" target="_blank">朝阳网警</a></span>
            <span><a href="https://www.zhipin.com/web/common/protocol/hr-service.html" rel="nofollow" ka="link-hr-service" target="_blank">人力资源服务许可证</a></span>
            <span><a href="https://www.12377.cn" rel="nofollow" ka="link-12377" target="_blank">网上有害信息举报专区</a></span>
            <span class="renshe-phone">朝阳区人社局监督电话</span> -->
        </p>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'newFooterAgain',
    data () {
      return {
        test: 1,
        hrefList: [
          {
            url: 'a.html',
            title: 'A股企业',
          },
          {
            url: '',
            title: '中概股企业',
          },
          {
            url: '',
            title: '未上市企业',
          },
          {
            url: '',
            title: '情绪因子',
          },
        ]
      }
    },
    computed: {
    },
    methods: {
      init () {
        console.log('asdad')
      },
      handleHrefClick (item) {
        // 新窗口打开本地html
        window.open(window.location.origin + '/' + item.url)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/footer/newFooterAgain.vue